import { render, staticRenderFns } from "./TodaysOrders.vue?vue&type=template&id=b6463744"
import script from "./TodaysOrders.vue?vue&type=script&lang=js"
export * from "./TodaysOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports